import { render, staticRenderFns } from "./BlackbookUpcomingRunners.vue?vue&type=template&id=65492bc5&scoped=true&"
import script from "./BlackbookUpcomingRunners.vue?vue&type=script&lang=js&"
export * from "./BlackbookUpcomingRunners.vue?vue&type=script&lang=js&"
import style0 from "./BlackbookUpcomingRunners.vue?vue&type=style&index=0&id=65492bc5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65492bc5",
  null
  
)

export default component.exports